var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchooltrack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_51422",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#79266a",
    floodOpacity: 0.141,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5599",
    "data-name": "Rectangle 5599",
    width: 36,
    height: 36,
    transform: "translate(103.707 406.707)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5596",
    "data-name": "Rectangle 5596",
    width: 36,
    height: 36,
    transform: "translate(-0.411 -0.411)",
    fill: "#c7e64b",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51436",
    "data-name": "Path 51436",
    d: "M8.41.343l28.263-3.8c2.29,0,8.635,19.92,0,31.823S16.308,45.626,10.479,45.818C1.021,46.132,0,35.666,0,33.6V12.077C0,5.6,3.765.343,8.41.343Z",
    transform: "translate(0 3.459)",
    fill: "#abc73e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5597",
    "data-name": "Rectangle 5597",
    width: 36,
    height: 36,
    transform: "translate(-0.411 -0.411)",
    fill: "#abc73e",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51439",
    "data-name": "Path 51439",
    d: "M9.658.51,27.449-.88c2.29,0,.7,9.345-6.323,15.879S-2.623,23.959-2.623,21.6L1.248,8.92A8.41,8.41,0,0,1,9.658.51Z",
    transform: "translate(2.623 0.88)",
    fill: "#869b34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5598",
    "data-name": "Rectangle 5598",
    width: 36,
    height: 36,
    transform: "translate(-0.411 -0.411)",
    fill: "#869b34",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b23a9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79266a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31148",
    "data-name": "Group 31148",
    transform: "translate(-0.268 -0.268)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.27, 0.27)",
    filter: "url(#Path_51422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_51422-2",
    "data-name": "Path 51422",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,0A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36 1 C 31.27458953857422 1 26.69105911254883 1.925247192382812 22.37673187255859 3.75006103515625 C 18.20906829833984 5.512832641601562 14.46591949462891 8.036598205566406 11.25125885009766 11.25125885009766 C 8.036598205566406 14.46591949462891 5.512832641601562 18.20906829833984 3.75006103515625 22.37673187255859 C 1.925247192382812 26.69105911254883 1 31.27458953857422 1 36 C 1 40.72541046142578 1.925247192382812 45.30894088745117 3.75006103515625 49.62326812744141 C 5.512832641601562 53.79093170166016 8.036598205566406 57.53408050537109 11.25125885009766 60.74874114990234 C 14.46591949462891 63.96340179443359 18.20906829833984 66.48716735839844 22.37673187255859 68.24993896484375 C 26.69105911254883 70.07475280761719 31.27458953857422 71 36 71 C 40.72541046142578 71 45.30894088745117 70.07475280761719 49.62326812744141 68.24993896484375 C 53.79093170166016 66.48716735839844 57.53408050537109 63.96340179443359 60.74874114990234 60.74874114990234 C 63.96340179443359 57.53408050537109 66.48716735839844 53.79093170166016 68.24993896484375 49.62326812744141 C 70.07475280761719 45.30894088745117 71 40.72541046142578 71 36 C 71 31.27458953857422 70.07475280761719 26.69105911254883 68.24993896484375 22.37673187255859 C 66.48716735839844 18.20906829833984 63.96340179443359 14.46591949462891 60.74874114990234 11.25125885009766 C 57.53408050537109 8.036598205566406 53.79093170166016 5.512832641601562 49.62326812744141 3.75006103515625 C 45.30894088745117 1.925247192382812 40.72541046142578 1 36 1 M 36 0 C 55.88224792480469 0 72 16.11774826049805 72 36 C 72 55.88224792480469 55.88224792480469 72 36 72 C 16.11774826049805 72 0 55.88224792480469 0 36 C 0 16.11774826049805 16.11774826049805 0 36 0 Z",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_51422-3",
    "data-name": "Path 51422",
    transform: "translate(0.268 0.268)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,0A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36 1 C 31.27458953857422 1 26.69105911254883 1.925247192382812 22.37673187255859 3.75006103515625 C 18.20906829833984 5.512832641601562 14.46591949462891 8.036598205566406 11.25125885009766 11.25125885009766 C 8.036598205566406 14.46591949462891 5.512832641601562 18.20906829833984 3.75006103515625 22.37673187255859 C 1.925247192382812 26.69105911254883 1 31.27458953857422 1 36 C 1 40.72541046142578 1.925247192382812 45.30894088745117 3.75006103515625 49.62326812744141 C 5.512832641601562 53.79093170166016 8.036598205566406 57.53408050537109 11.25125885009766 60.74874114990234 C 14.46591949462891 63.96340179443359 18.20906829833984 66.48716735839844 22.37673187255859 68.24993896484375 C 26.69105911254883 70.07475280761719 31.27458953857422 71 36 71 C 40.72541046142578 71 45.30894088745117 70.07475280761719 49.62326812744141 68.24993896484375 C 53.79093170166016 66.48716735839844 57.53408050537109 63.96340179443359 60.74874114990234 60.74874114990234 C 63.96340179443359 57.53408050537109 66.48716735839844 53.79093170166016 68.24993896484375 49.62326812744141 C 70.07475280761719 45.30894088745117 71 40.72541046142578 71 36 C 71 31.27458953857422 70.07475280761719 26.69105911254883 68.24993896484375 22.37673187255859 C 66.48716735839844 18.20906829833984 63.96340179443359 14.46591949462891 60.74874114990234 11.25125885009766 C 57.53408050537109 8.036598205566406 53.79093170166016 5.512832641601562 49.62326812744141 3.75006103515625 C 45.30894088745117 1.925247192382812 40.72541046142578 1 36 1 M 36 0 C 55.88224792480469 0 72 16.11774826049805 72 36 C 72 55.88224792480469 55.88224792480469 72 36 72 C 16.11774826049805 72 0 55.88224792480469 0 36 C 0 16.11774826049805 16.11774826049805 0 36 0 Z",
    stroke: "none",
    fill: "#adc927"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_428",
    "data-name": "Mask Group 428",
    transform: "translate(-85.439 -388.439)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31194",
    "data-name": "Group 31194",
    transform: "translate(96.707 391.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_423",
    "data-name": "Mask Group 423",
    transform: "translate(7.411 15.369)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User",
    transform: "translate(6.079 1.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51432",
    "data-name": "Path 51432",
    d: "M21.55,25.925H10.041c-3.178,0-5.755-2.27-5.755-5.07V19.84c0-5.04,4.638-9.126,10.359-9.126h2.3c5.721,0,10.359,4.086,10.359,9.126v1.014C27.305,23.655,24.729,25.925,21.55,25.925Z",
    transform: "translate(-4.286 6.303)",
    fill: "#c7e64b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51433",
    "data-name": "Path 51433",
    d: "M14.049,15.24a6.906,6.906,0,1,1,6.906-6.906,6.906,6.906,0,0,1-6.906,6.906Z",
    transform: "translate(-2.539 -1.429)",
    fill: "#c7e64b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_425",
    "data-name": "Mask Group 425",
    transform: "translate(0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_424",
    "data-name": "Mask Group 424",
    transform: "translate(7.411 15.369)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-2",
    "data-name": "User",
    transform: "translate(6.079 1.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51434",
    "data-name": "Path 51434",
    d: "M21.55,25.925H10.041c-3.178,0-5.755-2.27-5.755-5.07V19.84c0-5.04,4.638-9.126,10.359-9.126h2.3c5.721,0,10.359,4.086,10.359,9.126v1.014C27.305,23.655,24.729,25.925,21.55,25.925Z",
    transform: "translate(-4.286 6.303)",
    fill: "#abc73e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51435",
    "data-name": "Path 51435",
    d: "M14.049,15.24a6.906,6.906,0,1,1,6.906-6.906,6.906,6.906,0,0,1-6.906,6.906Z",
    transform: "translate(-2.539 -1.429)",
    fill: "#abc73e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_427",
    "data-name": "Mask Group 427",
    transform: "translate(0.457 6.842)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_426",
    "data-name": "Mask Group 426",
    transform: "translate(6.954 8.527)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-3",
    "data-name": "User",
    transform: "translate(6.079 1.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51437",
    "data-name": "Path 51437",
    d: "M21.55,25.925H10.041c-3.178,0-5.755-2.27-5.755-5.07V19.84c0-5.04,4.638-9.126,10.359-9.126h2.3c5.721,0,10.359,4.086,10.359,9.126v1.014C27.305,23.655,24.729,25.925,21.55,25.925Z",
    transform: "translate(-4.286 6.303)",
    fill: "#869b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51438",
    "data-name": "Path 51438",
    d: "M14.049,15.24a6.906,6.906,0,1,1,6.906-6.906,6.906,6.906,0,0,1-6.906,6.906Z",
    transform: "translate(-2.539 -1.429)",
    fill: "#869b34"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "_5699009381543238918",
    "data-name": 5699009381543239000,
    d: "M10.5,18.25S17,15,17,10.125V4.437L10.5,2,4,4.437v5.687C4,15,10.5,18.25,10.5,18.25Z",
    transform: "translate(37.268 36.018)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49021",
    "data-name": "Path 49021",
    d: "M26.617,16.788a.857.857,0,0,1-.612-.257l-1.252-1.268a.884.884,0,0,1,0-1.239.857.857,0,0,1,1.223,0l.641.649,1.893-1.917a.857.857,0,0,1,1.223,0,.884.884,0,0,1,0,1.239l-2.5,2.536A.857.857,0,0,1,26.617,16.788Z",
    transform: "translate(21.026 30.611)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchooltrack2);
export default __webpack_public_path__ + "static/media/schooltrack2.f12f239a18eec51d3016a0e78d0b8c11.svg";
export { ForwardRef as ReactComponent };